import { ThemeProvider as MuiThemeProvider } from "@mui/material";
import { ReactNode } from "react";

import { createTheme } from "../helpers/createTheme";

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const theme = createTheme();

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
